export const SAVE = 'TravellerMedicalBenefitsTugo.SAVE';
export const VALUE_CHANGED = 'TravellerMedicalBenefitsTugo.VALUE_CHANGED';
export const LOAD = 'TravellerMedicalBenefitsTugo.VALUE_LOAD';
export const NEXT = 'TravellerMedicalBenefitsTugo.NEXT';
export const RESET = 'TravellerMedicalBenefitsTugo.RESET';

export const RESET_FORM_STATE = 'TravellerMedicalBenefitsTugo.RESET_FORM_STATE';

export const MEDICAL_EXPENSE_TYPES = {
  DOCTORS_VISIT: "Doctor's Visit",
  DIAGNOSTIC_TESTS: 'Diagnostic Tests',
  PRESCRIPTION_DRUGS: 'Prescription Drugs',
  AMBULANCE_SERVICES: 'Ambulance Services',
  HOSPITALIZATION: 'Hospitalization',
  ESSENTIAL_MEDICAL_APPLIANCES: 'Essential Medical Appliances',
  PRIVATE_DUTY_NURSING: 'Private Duty Nursing',
  FRACTURE_TREATMENT: 'Fracture Treatment',
  UNEXPECTED_BIRTH_OF_CHILD: 'Unexpected Birth of a Child',
  PROFESSIONAL_SERVICES: 'Professional Services',
  DENTAL_SERVICES: 'Dental Services',
  REMOTE_EVACUATION: 'Remote Evacuation',
  VISION_CARE_HEARING_AIDS: 'Vision Care and Hearing Aids',
  AIR_TRAVEL_DELAY: 'Air Travel Delay',
  EXPENSES_RELATED_TO_DEATH_REPATRIATION: 'Expenses Related to Death',
  OTHER_UNRELATED_BENEFIT: 'Other (unrelated to any benefit listed above)',
};

/** Provider types for Professional Services (Standard VTC). Used for form keys and claim-code mapping. */
export const PROFESSIONAL_SERVICES_PROVIDERS = {
  PHYSIOTHERAPIST: 'physiotherapist',
  CHIROPRACTOR: 'chiropractor',
  CHIROPODIST: 'chiropodist',
  OSTEOPATH: 'osteopath',
  PODIATRIST: 'podiatrist',
  ACUPUNCTURIST: 'acupuncturist',
  OPTOMETRIST: 'optometrist',
};

/** Policy types where Professional Services shows a single consolidated expense box (no per-provider checkboxes), mapped to TRAV-PROFMED. */
export const LIST_POLICY_TYPE_CODE_SIMPLIFIED_PROFESSIONAL_SERVICES = ['PL-SPCK-2-T1', 'PL-SPCK-2-T2', 'PL-SPCK-2-T3'];



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TravellerMedicalBenefits/constants.js